import { render, staticRenderFns } from "./FormDrilldown.vue?vue&type=template&id=24e73bf8"
import script from "./FormDrilldown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDrilldown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports